module.exports = __webpack_public_path__ + "assets/dergrees.78999b77.svg";